import React from "react";

// Elementos decorativos sutiles (dirección de arte lifestyle / hospitality).
// Todos son SVG inline, sin interacción (pointer-events-none) y usan currentColor.
// Solo decoran: no afectan contenido, estructura ni funcionalidad.

const base = "pointer-events-none select-none";

export const Squiggle = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 200 24" fill="none" aria-hidden="true">
    <path
      d="M2 14C18 4 30 4 46 14S78 24 94 14s32-10 48 0 32 10 48 0"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const DotGrid = ({ className = "", rows = 6, cols = 6 }) => {
  const dots = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      dots.push(<circle key={`${r}-${c}`} cx={6 + c * 16} cy={6 + r * 16} r="2.2" fill="currentColor" />);
    }
  }
  return (
    <svg className={`${base} ${className}`} viewBox={`0 0 ${cols * 16} ${rows * 16}`} aria-hidden="true">
      {dots}
    </svg>
  );
};

export const Sprig = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 120 160" fill="none" aria-hidden="true">
    <path d="M60 158C60 120 58 70 70 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M64 120c18 2 30-8 34-26-18-2-30 8-34 26Z" stroke="currentColor" strokeWidth="2.2" />
    <path d="M58 96c-18 2-30-8-34-26 18-2 30 8 34 26Z" stroke="currentColor" strokeWidth="2.2" />
    <path d="M66 70c16 0 27-10 30-28-16 0-27 10-30 28Z" stroke="currentColor" strokeWidth="2.2" />
    <path d="M56 50c-15-1-25-11-27-28 15 1 25 11 27 28Z" stroke="currentColor" strokeWidth="2.2" />
  </svg>
);

export const Blob = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 200 200" aria-hidden="true">
    <path
      fill="currentColor"
      d="M44.8-66.3C57.9-57.4 67.7-44.2 72.6-29.4 77.5-14.6 77.4 1.8 72.3 16.2 67.2 30.6 57.1 43 44.3 53.7 31.5 64.4 16 73.4-1.5 75.6-19 77.8-38.4 73.2-52.6 62.1-66.8 51-75.8 33.4-78.9 14.9-82 -3.6-79.2-23 -70.2-38.5-61.2-54-46-65.7-29.4-71.4-12.8-77.1 5.1-76.8 21.7-71.7 38.3-66.6 31.7-75.2 44.8-66.3Z"
      transform="translate(100 100)"
    />
  </svg>
);

export const Sparkle = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path
      d="M20 2c2 10 6 14 16 18-10 4-14 8-16 18-2-10-6-14-16-18 10-4 14-8 16-18Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const Scribble = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 140 110" fill="none" aria-hidden="true">
    <path
      d="M70 8C40 6 14 22 12 50s24 52 58 52 58-22 56-50C124 30 108 16 84 12"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ArrowDoodle = ({ className = "" }) => (
  <svg className={`${base} ${className}`} viewBox="0 0 100 60" fill="none" aria-hidden="true">
    <path d="M4 10c30 0 54 8 72 34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M58 46c10 0 17-2 18-2-4-6-6-12-7-18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
